{
  "loading": "Betöltés folyamatban…",
  "placeholder": "Kiválasztás…"
}
